/* ════ EDGE AUTO-SCROLL ════════════════════════════════════ */
// While dragging/drawing/resizing near the left or right edge of the timeline,
// scroll the viewport in that direction so blocks can be dragged off-screen.
import { $ } from '../dom.js';

let timer = null, dir = 0;

export function updateEdgeScroll(clientX) {
  const ts = $('tl-scroll'); if (!ts) return;
  const r = ts.getBoundingClientRect(), M = 60;
  dir = clientX > r.right - M ? 1 : (clientX < r.left + M ? -1 : 0);
  if (dir && !timer) timer = setInterval(() => { ts.scrollLeft += dir * 14; }, 16);
  else if (!dir && timer) { clearInterval(timer); timer = null; }
}

export function stopEdgeScroll() {
  if (timer) { clearInterval(timer); timer = null; }
  dir = 0;
}
